<template>
  <div>
    <NavComponent v-if="pageName !== 'signup_app'" />
    <appNavigator v-if="pageName === 'signup_app'" :page="pageName" />
    <SignupPage />
    <Footer />
  </div>
</template>

<script>
import SignupPage from "@/pages/SignupPage.vue";
import NavComponent from "@/components/new/Nav.vue";
import Footer from "@/components/new/Footer.vue";
import AppNavigator from "@/components/appNavigator.vue";

export default {
  name: "SignupView",
  components: {
    AppNavigator,
    SignupPage,
    NavComponent,
    Footer,
  },
  data() {
    return {
      pageName: "",
    };
  },
  mounted() {
    this.pageName = this.$route.name;
  },
};
</script>

<style scoped>
.main {
  min-height: calc(100vh - var(--nav-height, 80px));
  margin-top: var(--nav-height, 80px);
}
</style>
